<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">餐饮菜单&gt;</div>
      </div>

      <div class="body_content">
        <div class="body_top">
          <button type="button" class="btn btn-default btn_option" data-toggle="modal" data-target="#myModal" style="width: 140px">
            新增
          </button>
        </div>
        <div class="classList_div">
          <table class="table table-striped table-bordered table_trainingManage">
            <thead>
            <tr>
              <th width="15%">日期</th>
              <th>菜谱</th>
              <th width="15%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(d, index) in dataList" :key="index">
              <td>{{d.menuDate}}({{d.menuDate|formatDay}})</td>
              <td style="text-align: left"><a class="picbox" @click="openImageModal(formatMenu(m,4))" href="javascript:" v-if="d.data" v-for="(m, mindex) in d.data.split(',')">
                <span class="cheader">{{m|formatMenu(3)|formatType}}</span>
                <img :src="resourcePath + formatMenu(m, 4)"/>
                <div class="glyphicon glyphicon-remove" @click.stop="deleteById(formatMenu(m ,2))"></div>
                <span :title="m | formatMenu(1)">{{m | formatMenu(1)}}</span>
              </a></td>

              <td>

                <div class="edit_pic" title="修改" @click="openSelect(d.menuDate)"></div>
                <div class="copy_pic" @click="openCopytDate(d.menuDate)" title="复制"></div>
                <div class="delete_pic" @click="deleteByDate(d.menuDate)" title="删除"></div>
              </td>
            </tr>
            </tbody>
          </table>
          <page-view v-bind="searchParams"></page-view>

          <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">
                    选择日期
                  </h4>
                </div>
                <div class="modal-body modal_work_trainingManage">
                  <div>
                    <input type="text" data-vv-scope="clazz" data-vv-as="日期" name="menuDate" class="form-control classInfo" id="menuDate" placeholder="输入日期" readonly v-model="data.menuDate"/>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" @click="openSelect()">确定</button>
                  <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
                </div>
              </div>
            </div>
          </div>

          <!--选择菜单-->
          <div class="modal fade" id="menuModal" tabindex="-1" role="dialog" aria-labelledby="menuModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-menu-content">
              <div class="modal-content ">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title">
                    今日菜单
                  </h4>
                </div>
                <div class="modal-body modal_work_trainingManage">
                  <div>
                    <select class="form-control modelInput" v-model="data.type" placeholder="类型"  data-vv-as="类型" name="type" @change="loadTodayList">
                      <option selected value="" disabled>- 请选择类型</option>
                      <option v-for="(t, key, index) in catering_type" :value="key">{{t}}</option>
                    </select>
                    <div class="munulist">
                      <h4>{{data.menuDate}}{{data.type|formatType}}已选</h4>
                      <a class="picbox" @click="openImageModal(m.filePath)" href="javascript:" v-for="(m, mindex) in dataTodayList">
                        <span class="cheader">{{m.type|formatType}}</span>
                        <img :src="resourcePath + m.filePath"/>
                        <div class="glyphicon glyphicon-remove" @click.stop="deleteById(m.id,1)"></div>
                        <span :title="m.name">{{m.name}}</span>
                      </a>
                    </div>
                    <div class="munulist">
                      <h4>{{data.menuDate}}{{data.type|formatType}}备选</h4>
                      <a class="picbox" @click="openImageModal(m.filePath)" href="javascript:" v-for="(m, mindex) in dataMenuList">
                        <span class="cheader">{{m.type|formatMenuType}}</span>
                        <img :src="resourcePath + m.filePath"/>
                        <div class="glyphicon glyphicon-ok" @click.stop="selectById(m.id)"></div>
                        <span :title="m.name">{{m.name}}</span>
                      </a>
                      <page-view v-bind="searchParams2"></page-view>
                    </div>


                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" data-dismiss="modal">关闭</button>
                </div>
              </div>
            </div>
          </div>

          <!--图片显示-->
          <div class="modal fade" id="myModal_showImage" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showImage" aria-hidden="true">
            <div class="modal-dialog modal-dialog-look">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    &times;
                  </button>
                  <h4 class="modal-title" id="myModalLabel_showImage">
                    图片预览
                  </h4>
                </div>
                <div class="modal-body modal-body-look">
                  <img :src="previewFilePath" class="previewImg"/>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from '../main';
  import {getContentSize} from './mainView';
  import pageView from './pageView';
  import dictionaryData from '../json/dictionary';
  import {Validator} from 'vee-validate';

  export default {
    name: "trainingManage",
    components:{pageView},
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        userId:this.$store.state.userId,
        resourcePath:  this.$store.state.serviceBase + "resources/",
        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,
        userCode: this.$store.state.userCode,

        //今日日期
        timeDate: '',
        //培训人员集合
        dataList:[],
        dataTodayList:[],
        dataMenuList:[],
        option_flag: 'add',

        //培训人员对象
        data:{
          menuDate:'',
          type:'1',
          menuId:""
        },
        resetDate:true,
        catering_type: dictionaryData.catering_type,
        searchParams: {
          all: 0,
          rows: 10,
          page:1
        },
        searchParams2: {
          type:"",
          all: 0,
          rows: 20,
          page:1
        },
        fromDate:"",
        previewFilePath:""
      }
    },
    filters: {
      formatMenu(v, i){
        if(!v) return null;
        let arr = v.split("|");
        if(arr.length>i)
          return arr[i];
      },
      formatType(value){
        let this_ = this;
        if(dictionaryData.catering_type && value){
          value = dictionaryData.catering_type[value];
        }
        return value;
      },
      formatMenuType(value){
        let this_ = this;
        if(dictionaryData.menu_type && value){
          value = dictionaryData.menu_type[value];
        }
        return value;
      },
      formatDay(value){
        let dayArr = {1:'一',2:'二',3:'三',4:'四',5:'五',6:'六',0:'日'};
        console.log(value, "  ", new Date(value).getDay())
        return "星期" + dayArr[new Date(value).getDay()];
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.initDataList();//日期

        //绑定加载关闭模态框时的事件
        this_.closeModal();
        this_.dateDefault();
        this_.searchParams.page = 1;
        this_.searchParams.pageCallback = this_.initDataList;
        this_.searchParams2.page = 1;
        this_.searchParams2.pageCallback = this_.loadMenuList;
      });
    },
    methods: {
      formatMenu(v, i){
        if(!v) return null;
        let arr = v.split("|");
        if(arr.length>i)
          return arr[i];
      },
            /**
       * 加载列表
       */
      initDataList(pageParams){
        let this_ = this;
        if(pageParams)
          Object.assign(this_.searchParams, pageParams);

        let _searchParams = {};
        Object.assign(_searchParams, this_.searchParams);
        delete _searchParams.pageCallback;//提交前删除回调
        schoolAxios({
          method: 'get',
          url: 'cateringToday/findPageByDate',
          params: _searchParams
        }).then(function (resp) {
          if(resp.data.success){
            // console.info(this_.userId);
            this_.dataList = resp.data.list;
            this_.searchParams.all = resp.data.totalPage;
            this_.searchParams.page = 1;
          }
        });
      },
      loadTodayList(){
        let this_ = this;

        schoolAxios({
          method: 'get',
          url: 'cateringToday/findList',
          params: {
            type: this_.data.type,
            menuDate: this_.data.menuDate
          }
        }).then(function (resp) {
          if(resp.data.success){
            // console.info(this_.userId);
            this_.dataTodayList = resp.data.list;
          }
        });
      },
      loadMenuList(pageParams){
        let this_ = this;
        if(pageParams)
          Object.assign(this_.searchParams2, pageParams);

        let _searchParams = {};
        Object.assign(_searchParams, this_.searchParams2);
        delete _searchParams.pageCallback;//提交前删除回调
        schoolAxios({
          method: 'get',
          url: 'cateringMenu/findPage',
          params: _searchParams
        }).then(function (resp) {
          if(resp.data.success){
            // console.info(this_.userId);
            this_.dataMenuList = resp.data.list;
            this_.searchParams2.all = resp.data.totalPage;
            this_.searchParams2.page = 1;
          }
        });
      },
      openSelect(date){//复制与新增共用窗口
        if(this.fromDate){//复制
          this.copyByDate()
          return;
        }
        if(date){
          this.data.menuDate = date;
        }
        this.resetDate = false;
        if(!this.data.menuDate){
          "请选择日期".showMessage();
          return;
        }
        $("#myModal").modal("hide");
        setTimeout(function () {
          $("#menuModal").modal("show");
        },500);
        this.loadMenuList();
        this.loadTodayList();
      },
      /**
       * 添加培训人员
       */
      selectById(id){
        let this_ = this;
        if(!this_.data.menuDate){
          "未选择日期".showMessage();
          return;
        }
        if(!this_.data.type){
          "未选择类型".showMessage();
          return;
        }
        this_.data.menuId = id;
            schoolAxios({
              method: "post",
              url: "cateringToday/add",
              data: this_.data
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                this_.loadTodayList();
              } else {
                (data.message||"添加失败").showMessage();
              }
        });
      },

      edit(d){
        let this_ = this;
        this_.data = d;
        this_.option_flag = "edit"
        $("#myModal").modal("show");
      },


      /**
       * 删除
       */
      deleteById(id, flag){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'cateringToday/delete/'+id,
            params: {}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              if(flag ==1){
                this_.loadTodayList();
              }else{
                this_.initDataList();
              }
            }else{
              (data.message||"删除失败").showMessage();
            }
          })
        })
      },
      deleteByDate(date){
        let this_ = this;
        ("确定删除" + date + "数据吗？").showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'cateringToday/deleteByDate',
            params: {
              menuDate: date
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
                this_.initDataList();
            }else{
              (data.message||"删除失败").showMessage();
            }
          })
        })
      },
      openCopytDate(date){
        this.fromDate = date;
        this.data.menuDate = date;
        $("#myModal").modal("show");
      },

      copyByDate(){
        let this_ = this;

        if(this_.toDate == this_.data.menuDate){
          "相同日期不能复制".showMessage();
          return;
        }
        schoolAxios({
          method: 'put',
          url: 'cateringToday/copyByDate',
          data: {
            fromDate: this_.fromDate,
            toDate: this_.data.menuDate
          }
        }).then(function (resp) {
          let data = resp.data;
          if(data.success){
              this_.initDataList()
            $("#myModal").modal("hide");
          }else{
            (data.message||"复制失败").showMessage();
          }
        })

      },
      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal").on('hide.bs.modal', function () {
          if(this_.resetDate == true)
            this_.data = {
              menuDate:"",
              menuId:"",
              type:"1"
            }
          this_.resetDate == true
          this_.option_flag= 'add'
          this_.fromDate = "";
        });
        $("#menuModal").on('hide.bs.modal', function () {
          this_.data = {
            menuDate:"",
            menuId:"",
            type:"1"
          }
          this_.resetDate == true
          this_.searchParams2.page = 1;
          this_.initDataList();
        });


      },


      /**
       * 打开图片模态框
       */
      openImageModal(filePath) {
        let this_ = this;
        this_.previewFilePath = this_.resourcePath + filePath;
        $("#myModal_showImage").modal("show");
      },
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#menuDate').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#menuDate").val();
          this_.data.menuDate = value;
          ev.preventDefault();
          ev.stopPropagation();
        });

      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .body_top {
    margin: 20px 0;
  }
  .searcharea{
    width: 80%;
    float: right;
    text-align: right;
  }
  .searcharea .form-control{
    display: inline-block;
    width: 160px;
  }
  .searcharea button{
    width: 60px;
  }
  .table_trainingManage {
    margin: 20px 0 0 0;
  }
  table tr{
    text-align: center;
  }
  table th {
    background: #cccccc;
    text-align: center;
  }
  .table-striped {
    /*background-color: #D7D7D7;*/
  }
  .edit_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/trainingManage/edit_mouseOver.png");
    background-size: 100% 100%;
    float: left;
    margin: 0 10px;
  }
  .delete_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/trainingManage/delete_mouseOver.png");
    background-size: 100% 100%;
    float: left;
    margin: 0 10px;
  }
  .copy_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/copy.png");
    background-size: 100% 100%;
    float: left;
    margin: 0 10px;
  }
  .modelInput{
    height: 34px;
    width: 90%;
    margin-top: 2%;
    margin-left: 5%;
  }
  #teachers_div {
    position: absolute;
    left: 42px;
    width: 86%;
    border: 1px grey solid;
    background-color: white;
    display: none;
  }
  #teachers_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #teachers_div option:hover {
    background-color: grey;
  }
  .form-control.modelInput {
    display: inline-block;
    width: 92%;
  }
  .show_edit_pic {
    background-image: url("../assets/img/right/clazz/edit_mouseOver.png");
    cursor: pointer;
  }
  .table_trainingManage tbody{
    height: 680px;
  }
  .description-content{
    width: 100%;
    height: 90px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }
  .picbox{
    height: 102px;
    width: 82px;
    display: inline-block;
    position: relative;
    text-align: center;
    margin: 2px;
  }
  .picbox img{
    height: 100px;
    width: 80px;
  }
  .picbox div{
    position: absolute;
    top: 1px;
    right: 1px;
  }
  .picbox span{
    width: 100%;
    display: inline-block;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    -moz-text-overflow: ellipsis;
  }
  .picbox .cheader{
    position: absolute;
    color: #fff;
    background-color: #2b2b2b;
    opacity: 0.3;
    top: 1px;
    left: 1px;
  }
  .munulist{
    min-height: 150px;
  }
  .modal-menu-content{
    width: 900px;
  }
</style>



// WEBPACK FOOTER //
// src/components/cateringToday.vue